<template>
  <component
    :is="component"
    :mask="mask"
    :masked="masked"
    :value="value"
    class="tw-bg-[#E1E1FF] tw-text-[#4F4F4F] tw-rounded-md tw-p-2 tw-max-w-full"
    type="text"
    @input="(val) => $emit('input', val)"
  />
</template>

<script>
import { TheMask } from 'vue-the-mask'
import CustomInput from '@/components/shared/CustomInput'

export default {
  components: {
    CustomInput,
    TheMask,
  },
  props: {
    value: {
      default: '',
      type: String,
      required: true,
    },
    mask: {
      type: String,
      required: false,
      default: '',
    },
    masked: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    component() {
      return this.mask ? 'TheMask' : 'CustomInput'
    },
  },
}
</script>

<style></style>
